import PermissionRoute from 'components/PermissionRoute';
import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import NotFound from 'scenes/NotFound';

import Actions from './ConnectActions';
import MyConnects from './MyConnects';

const Connect = () => {
  const base = '/producer/connect';
  return (
    <Switch>
      <Redirect exact to={`${base}/myconnects`} path={base} />
      <PermissionRoute action='myeduzz:connect:visualizar' path={`${base}/:connectId/actions`} component={Actions} />
      <PermissionRoute action='myeduzz:connect:visualizar' path={`${base}/myconnects`} component={MyConnects} />
      <Route path='*' component={NotFound} />
    </Switch>
  );
};
export default Connect;
